import { View, useWindowDimensions } from "react-native";

import { useAppTheme } from "@hooks/useAppTheme";

import { ProethicsSimulationContainer } from "../ProethicsSimulationContainer";
import { useIsActiveScenario } from "../hooks/useActiveScenario";

export const ProethicsSimulationItem = ({
	scenarioId,
}: {
	scenarioId?: string;
}) => {
	const { height } = useWindowDimensions();
	const theme = useAppTheme();
	// Gate rendering until the store reflects this item's scenario so another
	// scenario's transcript never flashes for a frame. Switching is centralised
	// in the session view, not driven from here.
	const isActive = useIsActiveScenario(scenarioId);

	return (
		<View
			style={{
				height: Math.max(520, height - 200),
				borderWidth: 1,
				borderColor: theme.colors.outlineVariant,
				borderRadius: theme.roundness,
				overflow: "hidden",
				backgroundColor: theme.colors.surface,
				position: "absolute",
				left: 0,
				right: 0,
				maxWidth: 960,
				marginHorizontal: "auto",
			}}
		>
			{isActive ? <ProethicsSimulationContainer /> : null}
		</View>
	);
};
